import { gql } from 'graphql-tag'

import { FRAGMENT_CONVERSATION_LIST_CONVERSATION } from '../ConversationList.hasura'

export const REALTIME_CONVERSATIONS_SUBSCRIPTION = gql`
  subscription RealtimeConversationsList($limit: Int, $currentUserId: Int!, $where: conversation_bool_exp!) {
    conversation(limit: $limit, where: $where, order_by: { last_message_created_at: desc }) {
      ...ConversationListConversation
    }
  }
  ${FRAGMENT_CONVERSATION_LIST_CONVERSATION}
`
